import React from 'react';
import {  Select } from "antd/lib";
import { IDocumentSelector } from "../type/upload-document-modal.types";

const DocumentTypeSelector: React.FC<IDocumentSelector> = (props) => {

    return (
        <>
            {props.showDocumentList && props.documentListOption &&
            <div className={'upload-document-modal__doc-select-wrapper'}>
                <span className={'label'}>
                    Document Type
                </span>
                <Select
                    value={props.selectedDocumentType}
                    options={props.documentListOption}
                    onChange={(val) => props.handleDocTypeChange(val)}
                    className={'dropdown'}
                />
            </div>
            }
        </>
    )
}

export default DocumentTypeSelector;
